export default __webpack_public_path__ + "locales/ro/SingleSignOn.json?hash=41f1ba5e50fc6016aa2aacabc03ffe91";